import PropTypes from "prop-types";
import { HelmetProvider } from "react-helmet-async";

export function SeoProvider({ children }) {
  return <HelmetProvider>{children}</HelmetProvider>;
}

SeoProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default SeoProvider;

